import { render, staticRenderFns } from "./AnalyticsHowYouLearntRadarChart.vue?vue&type=template&id=24be4599&"
import script from "./AnalyticsHowYouLearntRadarChart.vue?vue&type=script&lang=js&"
export * from "./AnalyticsHowYouLearntRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports